// src/components/Header.jsx
import React from "react";
import Logof from '../assets/img/logoclean.svg';

const Header = () => {
  return (
    <div className="header">
      <img src={Logof} alt="Farejando.Promo" className="logo" />
      <h1>farejando.promo</h1>
    </div>
  );
};

export default Header;